import { useCallback } from "react";
import { useSnackbar } from "./useSnackbar";
import { useLabels } from "./useLabels";

const labels = {
	unexpectedError: {
		label: "Label.HTML5Editor.UnexpectedError",
		default: "An unexpected error occured",
	},
} as const;
/**
 * Hook to give user feedback if an non blocking error occured
 */
// - Used a new hook so a shared default label can be used/fetched
// - Dod not combine with useErrorHandling to prevent useSnackbaar hook is loaded in most components
export function useErrorFeedback(
	options: {
		message?: string;
	} = {},
) {
	const { addSnackbar } = useSnackbar();
	const { message } = options;
	const [[defaultMessage]] = useLabels([labels.unexpectedError]);

	return {
		errorFeedback: useCallback(() => {
			const id = `error-${Math.ceil(Math.random() * 100000).toString(36)}`;
			addSnackbar({
				id,
				text: message || defaultMessage || labels.unexpectedError.default,
			});
		}, [addSnackbar, defaultMessage, message]),
	} as const;
}
